import { render, staticRenderFns } from "./CabeceraModalCreacion.vue?vue&type=template&id=c5c7faa2&scoped=true&"
import script from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalCreacion.vue?vue&type=style&index=0&id=c5c7faa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c7faa2",
  null
  
)

export default component.exports